import { differenceInDays, differenceInMonths } from 'date-fns'
import { useEffect, useState } from 'react'
export const useFrequency = (from?: number | null, to?: number | null) => {
  const [newFrequency, setNewFrequency] = useState([
    {
      label: 'Diario',
      value: 'daily',
    },
  ])

  useEffect(() => {
    let frequency = [
      {
        label: 'Diario',
        value: 'daily',
      },
    ]
    if (!!from && !!to) {
      const differenceD = differenceInDays(to, from)
      const differenceM = differenceInMonths(to, from)

      if (differenceD > 7)
        frequency.push({
          label: 'Semanal',
          value: 'weekly',
        })
      if (differenceM > 0)
        frequency.push({
          label: 'Mensual',
          value: 'month',
        })
    }
    setNewFrequency(frequency)
  }, [from, to])
  return newFrequency
}
